'use client';

import { BenzingaLogo } from '@benzinga/logos-ui';

export interface NavLogoProps {
  variant?: 'default' | 'dark';
  href?: string;
}

export const NavLogo = ({ variant = 'default', href = '/' }: NavLogoProps) => (
  <a
    className="inline-flex items-center text-[var(--hubnav-fg)] no-underline focus-visible:rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--hubnav-accent)] [&_span[class*='BenzingaLogo']]:inline-flex [&_span[class*='BenzingaLogo']]:h-[22px] [&_span[class*='BenzingaLogo']]:w-auto [&_span[class*='BenzingaLogo']]:items-center [&_span[class*='BenzingaLogo']_svg]:h-[22px] [&_span[class*='BenzingaLogo']_svg]:w-auto max-[1400px]:[&_span[class*='BenzingaLogo']]:h-5 max-[1400px]:[&_span[class*='BenzingaLogo']_svg]:h-5"
    href={href}
    aria-label="Benzinga — home"
  >
    <span className="sr-only">Benzinga</span>
    <BenzingaLogo deviceType="desktop" variant={variant === 'dark' ? 'light' : 'dark'} />
  </a>
);
